import { render, staticRenderFns } from "./PublicNavMenu.vue?vue&type=template&id=28fdd8df&"
import script from "./PublicNavMenu.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./PublicNavMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports